import datepicker from 'js-datepicker'

window.AppointmentForm = {
    init(dates) {
        const availableDates = Object.keys(dates)

        const toGermanFormat = (date) => [
                ('0' + date.getDate()).substr(-2),
                ('0' + (date.getMonth() + 1)).substr(-2),
                date.getFullYear(),
            ].join('.')

        const toEnglishFormat = (date) => [
                date.getFullYear(),
                ('0' + (date.getMonth() + 1)).substr(-2),
                ('0' + date.getDate()).substr(-2),
            ].join('-')

        const el = (tag, attributes = {}, value = null) => {
            const res = document.createElement(tag)
            for (const key of Object.keys(attributes)) {
                res.setAttribute(key, attributes[key])
            }
            if (value) {
                res.innerText = value
            }
            return res
        }

        const form = document.getElementById('booking-form')
        const appointmentInput = form.querySelector('#appointment-input')

        const onTimeSelect = (time) => {
            const list = form.querySelector('#appointments')
            list.querySelectorAll('a')
                .forEach(a => {
                    if (a.getAttribute('data-id') !== time.id) {
                        a.classList.remove('selected')
                    } else {
                        a.classList.add('selected')
                    }
                })
            appointmentInput.value = time.id
        }

        const inputDate = form.querySelector('#appointment-date')
        const timeWrapper = form.querySelector('#appointment-time-wrapper')

        inputDate.addEventListener('keydown', e => e.preventDefault())
        inputDate.addEventListener('keyup', e => e.preventDefault())

        const noTimesText = timeWrapper.getAttribute('data-no-available-times')

        datepicker(inputDate, {
            disabler: (date) => {
                return !availableDates.includes(
                    toEnglishFormat(date)
                )
            },
            formatter: (input, date, instance) => {
                input.value = toGermanFormat(date)
            },
            onSelect: (instance, date) => {
                appointmentInput.value = ''
                const value = toEnglishFormat(date)

                if (typeof dates[value] !== 'undefined') {
                    const times = dates[value]

                    const list = el('ul', {
                        id: 'appointments'
                    })

                    for (const time of times) {
                        const listItem = el('li')
                        const link = el(
                            'a',
                            {
                                href: 'javascript:void(0)',
                                'data-id': time.id,
                            },
                            time.value
                        )
                        link.addEventListener('click', () => {
                            onTimeSelect(time)
                        })
                        listItem.appendChild(
                            link
                        )
                        list.appendChild(listItem)
                    }

                    timeWrapper.innerHTML = ''
                    timeWrapper.appendChild(list)
                } else {
                    timeWrapper.innerText = noTimesText
                }

                timeWrapper.parentNode.style.display = 'block'
            }
        })
    }
}